import React from "react";
import Posts from "../components/Post/Posts.jsx";
import Pagination from "../components/Post/Pagination.jsx";

import fitvids from "fitvids";
class PostsContainer extends React.Component {

	constructor(props){

		super(props);

    const pageNumber = props.pageNumber || 1;


    this.initialState = {
      isComponentMounted:false,
      postsPerPage: 10,
      posts:[],
      totalPostsCount:0,
      currentPageNumber:pageNumber
    };

    this.state = {...this.initialState};

	}

  componentDidMount(){

    this.state.isComponentMounted = true;

    this.fetchPosts(this.state.currentPageNumber);

  }

  shouldComponentUpdate(nextProps, nextState){


    if (
      typeof nextProps.pageNumber !== "undefined" &&
      this.state.currentPageNumber !== nextProps.pageNumber
    ){

      this.state.currentPageNumber = nextProps.pageNumber
      this.fetchPosts(this.state.currentPageNumber);

      return false;
    }

    return true;

  }

  componentDidUpdate(prevProps){


    process.env.NODE_ENV === "production" && window.scroll(0, 0);

    fitvids();

  }

  componentWillUnmount(){

    this.state = {...this.initialState};

  }



	render() {

    if (this.state.posts == null) return null;

    return (
      <>

        <Posts posts={this.state.posts} />
        <Pagination
          postCounts={this.state.totalPostsCount}
          postsPerPage={this.state.postsPerPage}
          pageUpdateHandler={this.pagenationPageUpdateHandler.bind(this)}
          paginationNumber={ this.state.currentPageNumber  }
        />

      </>
    )
	}

  pagenationPageUpdateHandler(data){

    const nextPageNumber = Number(data.selected) + 1

    if (nextPageNumber === 1) {
      this.props.navigate("/posts")
    }else{
      this.props.navigate("/posts/" + nextPageNumber)
    }

  }

  fetchPosts(forPageNumber){

    const { group, pageCount, index } = this.props.pageContext

    const posts = group.map(({ node: post }) => { return post })

    this.state.isComponentMounted && this.setState({

      posts:posts,
      totalPostsCount: group.length * pageCount, // not accurate
      currentPageNumber: index,
      postsPerPage:group.length

    })


  }


}

export default PostsContainer;
